<template>
  <page-status class="insure-result" :loading="loading">
    <page-result
      :image="image"
      :title="title"
      :desc="desc"
      :showHotline="false"
    >
      <div v-if="times > 0" class="btn" @click="toCertify()">再试一次</div>
    </page-result>
  </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import PageResult from '@/components/PageResult';
import imgSuccess from '@/assets/img-status-success.png';
import imgError from '@/assets/img-status-error.png';
import * as services from '@/services';

export default {
  name: 'CertifyResult',
  components: {
    PageStatus,
    PageResult,
  },
  data() {
    return {
      loading: true,
      image: '',
      title: '',
      desc: '',
      times: 0,
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },

  methods: {
    fetchData() {
      const {
        businessNo,
        certifyId,
        response,
        error,
        message,
      } = this.$route.query;

      if (!error) {
        let id = certifyId;

        if (response) {
          try {
            const res = JSON.parse(response);
            id = res.extInfo.certifyId;
          } catch (error) {}
        }

        this.getResult(businessNo, id);
      } else {
        this.loading = false;
        this.image = imgError;
        this.title = '身份识别失败';
        this.desc = message
          ? message
          : error === 'version'
          ? '请将支付宝升级到最新版本'
          : '';
      }
    },

    getResult(businessNo, certifyId) {
      services.getCertifyResult(businessNo, certifyId).then(res => {
        const {
          passed,
          times,
          mobile,
          agentPhone = '',
          message,
          checkSignFlag,
          checkMessageFlag,
        } = res.data;
        this.loading = false;
        this.times = times;
        this.query = { businessNo, mobile };

        if (passed === 1) {
          this.image = imgSuccess;
          this.title = '身份识别成功';
          this.toNextPage(checkSignFlag, checkMessageFlag, mobile);
        } else {
          this.image = imgError;
          this.title = '身份识别失败';
          if (times > 0) {
            this.desc = `还有${times}次尝试机会`;
          } else if (message) {
            this.desc = message;
          } else {
            this.desc = `请联系操作业务员 ${agentPhone}`;
          }
        }
      });
    },

    toNextPage(checkSignFlag, checkMessageFlag, mobile) {
      const query = this.$route.query;
      if (checkSignFlag) {
        this.$router.replace({
          path: '/signature',
          query: { ...query, mobile },
        });
      } else if (checkMessageFlag) {
        this.$router.replace({
          path: '/proposal-auth',
          query: { ...query, mobile },
        });
      } else {
        this.$router.replace({
          path: '/insure-payment',
          query: { ...query, mobile },
        });
      }
    },

    toCertify() {
      const { businessNo, mobile } = this.query;
      this.$router.replace({
        path: '/certify',
        query: { businessNo, mobile },
      });
    },
  },
};
</script>

<style lang="less">
.insure-result {
  height: 100%;

  .page-result {
    background-color: #ffffff;

    .btn {
      width: 160px;
      height: 44px;
      line-height: 44px;
      border-radius: 4px;
      border: solid 1px #1665d8;
      text-align: center;
      color: #1665d8;
      font-size: 18px;
      margin: 0 auto;
    }
  }
}
</style>
